import { ApolloClient } from '@apollo/client';
import { createApolloCache } from './cache';
import { link } from './link';
import { bombasGraph, storefrontGraph } from '../util/config';

const client = new ApolloClient({
  link: link(storefrontGraph, bombasGraph)(),
  cache: createApolloCache()
});

export default client;
